import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { api, errorMessage } from '../api/client';
import { useSession } from '../auth/session';
import { Field, FormError, useSubmit } from '../components/Field';
import { AuthCard } from '../components/Layout';

function RegisterForm({ token, expiresAt }: { token: string; expiresAt: string }) {
  const { signedIn } = useSession();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [password, setPassword] = useState('');
  const form = useSubmit(() => api.redeemInvite(token, { username, displayName, password }), ({ user }) => {
    signedIn(user);
    void navigate('/', { replace: true });
  });
  const errors = form.fieldErrors;
  return (
    <>
      <p className="muted">You were invited to Couch. This link works once, until {new Date(expiresAt).toLocaleDateString(undefined, { dateStyle: 'medium' })}.</p>
      <form onSubmit={form.submit} noValidate>
        <Field label="Username" name="username" value={username} onChange={setUsername} autoComplete="username" error={errors.username} hint="3–32 characters: letters, digits, dot, dash, underscore." />
        <Field label="Display name" name="displayName" value={displayName} onChange={setDisplayName} autoComplete="name" error={errors.displayName} />
        <Field label="Password" name="password" type="password" value={password} onChange={setPassword} autoComplete="new-password" error={errors.password} hint="At least 10 characters." />
        <FormError message={form.formError} />
        <button type="submit" disabled={form.pending}>Create account</button>
      </form>
    </>
  );
}

export function InvitePage() {
  const { token = '' } = useParams();
  const invite = useQuery({ queryKey: ['invite', token], queryFn: () => api.lookupInvite(token), retry: false });
  return (
    <AuthCard title="Join Couch">
      {invite.isPending && <p role="status">Checking your invite…</p>}
      {invite.isError && <p role="alert" className="form-error">{errorMessage(invite.error)}</p>}
      {invite.isSuccess && <RegisterForm token={token} expiresAt={invite.data.expiresAt} />}
    </AuthCard>
  );
}
